import { IWixCollection, IWixCollectionTransformed, IWixProduct } from "../models/types/wixProduct.types";

export function addExpandProperties(products: IWixProduct[] | any): IWixProduct[] | any {
  return products?.map((product: any) => ({
    ...product,
    unselectable:
      product.faire_product_id ||
      product.exported_faire_product_id ||
      product.wix_product_id ||
      product.exported_wix_product_id ||
      product.is_exporting
        ? true
        : false,
    ...(product.numberOfVariants > 0 && {
      expandable: true,
      expanded: false,
    }),
  }));
}

export function addCollectionAndTransform(originalCollections: IWixCollection[]): IWixCollectionTransformed[] {
  const transformedCollections = originalCollections?.map((originalCollection) => ({
    id: originalCollection.collectionId,
    value: originalCollection.name,
  }));

  return [{ id: "", value: "All Categories" }, ...transformedCollections];
}

export function addCollectionExpandProperties(collections: IWixCollection[]): IWixCollection[] {
  return collections?.map((collection) => ({
    ...collection,
    expandable: true,
    expanded: false,
  }));
}

/**
 * Truncates a text's character based on number specified
 * @param str
 * @param n
 * @returns
 */

export function truncateText(str: string, n: number) {
  return str?.length > n ? str.slice(0, n - 1) + "...." : str;
}

/**
 * Remove Duplicates from an array
 * @param array
 * @returns
 */
export function removeDuplicates(array: any) {
  return [...new Set(array)];
}

export function mergeArrays(inputObj: { [key: number]: number[] | undefined }): number[] {
  const mergedArray: number[] = [];

  for (const key in inputObj) {
    if (inputObj.hasOwnProperty(key)) {
      const originalList = inputObj[key];
      if (originalList) {
        mergedArray.push(...originalList);
      }
    }
  }

  return mergedArray;
}

/**
 * Rounds a number to the nearest integer
 * @param value
 * @returns
 */
export function roundToNearest(value: number): number {
  return Math.abs(value % 1) >= 0.5 ? Math.ceil(value) : Math.floor(value);
}

/**
 * Generates a random string
 *
 * @param int length_
 * @return string
 */
export function randomString(length: number) {
  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz".split("");

  if (typeof length !== "number") {
    length = Math.floor(Math.random() * chars.length);
  }

  var str = "";

  for (var i = 0; i < length; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
}
